import { Link } from "@tanstack/react-router"
import { Alert } from "design-system/atoms/Alert"
import { Info } from "lucide-react"
import { useTranslation } from "react-i18next"

export const SignatureBanner = () => {
  const { t } = useTranslation()

  return (
    <Alert className="flex items-center gap-2 [&>svg]:static [&>svg~*]:pl-0">
      <Info className="h-4 w-4 shrink-0" />
      <span>
        {t("settings.channels.signatureBanner.message")}{" "}
        <Link
          to="/settings/customization"
          search={{ tab: "email" }}
          className="underline font-medium"
        >
          {t("settings.channels.signatureBanner.link")}
        </Link>
      </span>
    </Alert>
  )
}
